import { Box } from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

// Constants
import { defiUrls, defiIcons, defiLabels } from "constants/defi";
import { CustomArrowProps } from "react-slick";

// Images
import usdcIcon from "assets/images/defi/usdcIcon.png";
import usdcDarkIcon from "assets/images/defi/usdc-dark.png";
import { currentNetworkInfo } from "config/network";

function SampleNextArrow(props: CustomArrowProps) {
  const { className, onClick } = props;

  return (
    <Box
      className={className}
      onClick={onClick}
      bg="#EFE5FF"
      borderRadius="50%"
      fontSize="2rem"
      h="32px"
      w="32px"
      _hover={{
        bg: "#EFE5FF",
      }}
    >
      <FiChevronRight color="#7630EC" />
    </Box>
  );
}

function SamplePrevArrow(props: CustomArrowProps) {
  const { className, onClick } = props;

  return (
    <Box
      className={className}
      onClick={onClick}
      bg="#EFE5FF"
      borderRadius="50%"
      fontSize="2rem"
      h="32px"
      w="32px"
      _hover={{
        bg: "#EFE5FF",
      }}
    >
      <FiChevronLeft color="#7630EC" width="20px" height="20px" />
    </Box>
  );
}

export const slickSettings = {
  className: "slick-view",
  edgeFriction: 1,
  swipeToSlide: true,
  infinite: false,
  speed: 500,
  slidesToShow: 2.7,
  slidesToScroll: 1,
  initialSlide: 0,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 2.4,
        dots: false,
      },
    },
    {
      breakpoint: 1380,
      settings: {
        slidesToShow: 2.1,
        dots: false,
      },
    },
    {
      breakpoint: 1278,
      settings: {
        slidesToShow: 4.8,
        dots: false,
      },
    },
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 4.2,
        dots: false,
      },
    },
    {
      breakpoint: 1000,
      settings: {
        slidesToShow: 3.8,
        dots: false,
      },
    },
    {
      breakpoint: 940,
      settings: {
        slidesToShow: 3.6,
        dots: false,
      },
    },
    {
      breakpoint: 788,
      settings: {
        slidesToShow: 3.4,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2.4,
        dots: false,
      },
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 2.1,
        dots: true,
        nextArrow: undefined,
        prevArrow: undefined,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1.5,
        dots: true,
        nextArrow: undefined,
        prevArrow: undefined,
      },
    },
    {
      breakpoint: 376,
      settings: {
        slidesToShow: 1.3,
        dots: true,
        nextArrow: undefined,
        prevArrow: undefined,
      },
    },
  ],
};

export const defiOptions = [
  {
    id: "quickswap",
    icon: defiIcons["quickswap"],
    token: "Matic",
    tokenIcon: currentNetworkInfo.icon,
    partnerName: defiLabels["quickswap"],
    showTvl: false,
    link: defiUrls.quickswap.addLiquidity,
  },
  {
    id: "cian",
    icon: defiIcons["cian"],
    partnerName: defiLabels["cian"],
    showTvl: false,
    link: defiUrls.cian.deposit,
  },
  {
    id: "ovix",
    icon: defiIcons["ovix"],
    partnerName: defiLabels["ovix"],
    showTvl: false,
    link: defiUrls.ovix.supply,
  },
  {
    id: "balancer",
    icon: defiIcons["balancer"],
    token: "Matic",
    tokenIcon: currentNetworkInfo.icon,
    partnerName: defiLabels["balancer"],
    showTvl: false,
    link: defiUrls.balancer.addLiquidity,
  },
  {
    id: "olive",
    icon: defiIcons["olive"],
    partnerName: defiLabels["olive"],
    showTvl: false,
    link: defiUrls.olive.deposit,
    showIcon: false,
  },
  {
    id: "meshswap1",
    icon: defiIcons["meshswap"],
    token: "Matic",
    tokenIcon: currentNetworkInfo.icon,
    partnerName: defiLabels["meshswap"],
    showTvl: false,
    link: defiUrls.meshswap1.addLiquidity,
  },
  {
    id: "quickswap",
    icon: defiIcons["quickswap"],
    token: "Matic",
    tokenIcon: currentNetworkInfo.icon,
    partnerName: defiLabels["quickswap"],
    showTvl: false,
    link: defiUrls.quickswap.addLiquidity,
  },
  {
    id: "meshswap2",
    icon: defiIcons["meshswap"],
    token: "USDC",
    tokenIcon: { light: usdcIcon, dark: usdcDarkIcon },
    partnerName: defiLabels["meshswap"],
    showTvl: false,
    link: defiUrls.meshswap2.addLiquidity,
  },
  {
    id: "beefyBalancer",
    icon: defiIcons["beefy"],
    token: "Matic",
    tokenIcon: currentNetworkInfo.icon,
    partnerName: defiLabels["beefy"],
    showTvl: false,
    link: defiUrls.beefyBalancer.deposit,
  },
];
